module.exports = __webpack_public_path__ + "static/media/2025_Greenland_Business_Association_(GE).5ed2d095.pdf";